import React from "react";
import "./CustomerStats.css";

const CustomerStats = ({ customers }) => {
  const totalCustomers = customers.totalCustomers || 0;
  const repeatCustomers = customers.repeatCustomers || 0;
  const newCustomers = customers.newCustomers || 0;

  const retention =
    totalCustomers > 0
      ? ((repeatCustomers / totalCustomers) * 100).toFixed(1)
      : 0;

  const stats = [
    {
      title: "Total Customers",
      value: totalCustomers,
      icon: "👥",
      color: "#2563eb",
    },
    {
      title: "New Customers",
      value: newCustomers,
      icon: "🆕",
      color: "#10b981",
    },
    {
      title: "Repeat Customers",
      value: repeatCustomers,
      icon: "🔁",
      color: "#f59e0b",
    },
    {
      title: "Retention",
      value: `${retention}%`,
      icon: "📈",
      color: "#8b5cf6",
    },
  ];

  return (
    <div className="customer-stats">

      <div className="customer-header">
        <h2>👥 Customer Statistics</h2>
        <p>Customer engagement overview</p>
      </div>

      <div className="customer-grid">
        {stats.map((item, index) => (
          <div
            className="customer-card"
            key={index}
          >
            <div
              className="customer-icon"
              style={{
                background: item.color,
              }}
            >
              {item.icon}
            </div>

            <div className="customer-info">
              <h3>{item.value}</h3>
              <p>{item.title}</p>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default CustomerStats;